<!-- <h2 mat-dialog-title>{{ 'category' | translate }}</h2> -->
<div mat-dialog-content>
    <div>
        {{ 'item_selection_resused' | translate: {itemSelection: getNonEmptyText(data.itemSelectionTitle)} }}
    </div>
    <app-data-table [data]="data.reusedInMenuItems" [columns]="columns">
    </app-data-table>
</div>
<div mat-dialog-actions align="end">
    <!-- <button mat-button [mat-dialog-close]="data">{{ 'ok' | translate }}</button> -->
    <button mat-button (click)="closeDialog()">{{ 'close' | translate }}</button>
</div>
